module.exports = {
      id: "close-bold-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#close-bold",
      toString: function () {
        return this.url;
      }
    }